/**
 * Who is signed in, and the way out — in the header, on every screen.
 *
 * Two reasons it is not tucked into diagnostics. The first is the shared iPad:
 * MSAL's cache is `localStorage` (see `msalAuth.ts`) so a session survives the
 * app being closed, and the person who has to be able to end it is whoever is
 * holding the device — not whoever can find `/about`. The second is that a
 * manager glancing at the header should be able to see *which* account is about
 * to post a count to Business Central.
 *
 * Renders nothing outside `entra` mode, so the dev-mode screens are exactly the
 * ones D1 shipped: the shim has its own banner (fence 3), and a second identity
 * strip beside it would only make a dev screenshot ambiguous.
 */
import { useAuth } from "./AuthContext";

export function SessionBar() {
  const { authMode, signedIn, displayName, upn, signOut } = useAuth();

  if (authMode !== "entra" || !signedIn) return null;

  return (
    <div className="session-bar" data-testid="session-bar">
      <span className="session-bar__who" title={upn ?? undefined}>
        {displayName ?? upn}
      </span>
      <button type="button" className="session-bar__out" onClick={signOut} data-testid="sign-out">
        Sign out
      </button>
    </div>
  );
}
